import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { SystemRequestService } from '../../service/system-request/system-request.service';
import { SystemRequestTypesService } from '../../service/system-request-types/system-request-types.service';
// import { SystemRequestTypificationsService } from '../../service/system-request-typifications/system-request-typifications.service';
import { SystemsRequest } from '../../class/systems-request';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { AbstractControl, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SelectItem, DataTable } from 'primeng/primeng';
import { config } from '../../../../../environments/config';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';
import { getDiffDate } from '../../../../theme/functions/getDiffDate.function';

@Component({
  selector: 'app-systems-requests',
  templateUrl: './systems-requests.component.html',
  styleUrls: ['./systems-requests.component.scss']
})
export class SystemsRequestsComponent implements OnInit, OnDestroy {
  @ViewChild('gb') searchFilter;
  @ViewChild('dt') dataTable: DataTable;

  public modNew = false;
  public modView = false;
  public promiseForm: Promise<any>;
  public msgs: Message[] = [];

  public requestData: any[];

  public selectSystemsRequests: SystemsRequest;

  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;
  public loading: boolean = true;

  public es: any;
  public showFilter: boolean;
  public verification: boolean;
  public myEmployeeId: string;

  public filters: {key: string, value: string}[];
  public first = 0;

  public form_filter: FormGroup;
  public form_export: FormGroup;
  public openSystemsRequests= false;
  public systemsRequestsID: Number=0;
  public modExportDialog: boolean;
  public locationOptions:any[];
  public typeRequestOptions:any[];
  public contactOptions:any[];
  public statusOptions:any[];
  public reportTypeExportExcelOptions:any[];
  public apiUrl = config.API_ROOT;

  constructor(
    public systemRequestService: SystemRequestService,
    public systemRequestTypesService: SystemRequestTypesService,
    // public systemRequestTypificationsService: SystemRequestTypificationsService,
    public confirmationService: ConfirmationService,
    public translate: TranslateService,
    public hasPermissionService: HasPermissionService,
    private route: ActivatedRoute,
    public activatedRoute: ActivatedRoute,
    public fb: FormBuilder
  ) {
    this.es = calendarES();

    this.locationOptions = [
      {label: 'Todos', value: 'all'},
      {label: 'Casa', value: 'Casa'},
      {label: 'Cliente', value: 'Cliente'},
      {label: 'Redes Humanas', value: 'Redes Humanas'},
    ];

    this.typeRequestOptions = this.getSystemRequestTypes();

    this.contactOptions = [
      {label: 'Todos', value: 'all'},
      {label: 'Empresa', value: 'Empresa'},
      {label: 'Teléfono', value: 'Teléfono'},
    ];

    this.statusOptions = [
      {label: 'Todos', value: 'all'},
      {label: 'Abierto', value: 'Abierto'},
      {label: 'En trámite', value: 'En trámite'},
      {label: 'Escalado', value: 'Escalado'},
      {label: 'Cerrado', value: 'Cerrado'},
      {label: 'Calificado', value: 'Calificado'},
    ];

    this.modExportDialog = false;
    this.loading = false;

    this.reportTypeExportExcelOptions = [
      {label: 'Reporte de TI - General', value: 'Reporte de TI - General'},
      {label: 'Reporte de TI - Última respuesta', value: 'Reporte de TI - Última respuesta'},
    ];
  }

  ngOnInit() {
    this.page = 1;
    this.per_page = 10;
    this.sort = '-id';

    this.showFilter = true;
    this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;
    this.filters = [];

    this.createFormFilter(null);
    this.createFormExport(null);
  }

  ngOnDestroy() {
    
  }

  createFormFilter (data:any=null){
    data = data||{
      craeted_by_filter: null,
      type_request_filter: '',
      location_filter: 'all',
      venue_filter: '',
      contact_filter: 'all',
      status_filter: 'all',
    };

    this.form_filter = this.fb.group({
      created_by_filter: [ data.created_by_filter ],
      type_request_filter: [ data.type_request_filter ],
      location_filter: [ data.location_filter ],
      venue_filter: [ data.venue_filter ],
      contact_filter: [ data.contact_filter ],
      status_filter: [ data.status_filter ],
    });
  }

  createFormExport (data:any=null){
    data = data||{
      report_type: '',
      date_start: '',
      date_end: '',
      type_request: ''
    };

    this.form_export = this.fb.group({
      report_type: [ data.report_type, [ Validators.required ] ],
      date_start: [ data.date_start, [ Validators.required ] ],
      date_end: [ data.date_end, [ Validators.required ] ],
      type_request: [ data.type_request, [ Validators.minLength(1) ] ],
    });
  }

  public loadSystemsRequestLazy(event: LazyLoadEvent) {
    this.page = (event.first / this.per_page) + 1;

    if (event.sortOrder === -1)
      this.sort =  '-' + event.sortField;
    else
      this.sort =  event.sortField;

    if (event.globalFilter)
      this.query = event.globalFilter;
    else
      this.query = undefined;

    this.sort = '-id';

    this.getSystemsRequests();
  }

  public showExportDialog() {
    this.modExportDialog = true;
  }

  public cancelExport() {
    this.modExportDialog = false;
  }

  public exportReportExcel(values) {
    let d = new Date(values.date_start);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    const date_start = formatDate(d);

    d = new Date(values.date_end);
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
    d.setMilliseconds(59);
    const date_end = formatDate(d);

    let url = this.apiUrl + '/systems-request/excel?' +
    'token=' + localStorage.getItem('token') +
    '&_page=1&_limit=100000&_sort=id&';

    if (date_start)
      url = url + 'date_request-min=' + date_start + '&';

    if (date_end)
      url = url + 'date_request-max=' + date_end + '&';

    if (values.type_request !== '')
      url = url + 'type_request_id=' + values.type_request + '&';

    window.open(url + '&type=' + values.report_type.value, '_blank');
  }

  public newSystemsRequests() {
    this.modNew = !this.modNew;
    this.selectSystemsRequests = null;
  }

  public savedSystemsRequests(res) {
    this.msgs = [];
    this.msgs.push(res);
    this.selectSystemsRequests = null;
    this.modNew = false;
    // this.getSystemsInventoryRequest();//Comentado porque existe componente y se quita y detecta load_lazy
  }

  public cancelSystemsRequests (res) {
    this.selectSystemsRequests = null;
    this.modNew = false;
    this.modView = false;
    // this.getSystemsInventoryRequest();//Comentado porque existe componente y se quita y detecta load_lazy
  }

  public edit(systemsRequests: SystemsRequest) {
    this.modNew = true;
    this.selectSystemsRequests = systemsRequests;
  }

  public view(systemsRequests: SystemsRequest) {
    this.openSystemsRequests = true;
    this.selectSystemsRequests = systemsRequests;
    this.systemsRequestsID = systemsRequests.id;
    this.modView = true;
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public filter(values?) {
    this.page = 1;
    this.first = 0;
    this.filters = [];

    if (values.created_by_filter !== null && values.created_by_filter !== '' && values.created_by_filter !== undefined)
      this.filters.push({'key': 'created_by_id', 'value': values.created_by_filter.id});

    if(values.venue_filter !== null && values.venue_filter !== '' && values.venue_filter !== undefined)
      this.filters.push({'key': 'venue_id', 'value': values.venue_filter});

    if(values.type_request_filter !== 'all' && values.type_request_filter !== null && values.type_request_filter !== '' && values.type_request_filter !== undefined)
      this.filters.push({'key': 'type_request_id', 'value': values.type_request_filter});

    if(values.location_filter !== 'all' && values.location_filter !== null && values.location_filter !== '' && values.location_filter !== undefined)
      this.filters.push({'key': 'location', 'value': values.location_filter});

    if(values.contact_filter !== 'all' && values.contact_filter !== null && values.contact_filter !== '' && values.contact_filter !== undefined)
      this.filters.push({'key': 'contact_medium', 'value': values.contact_filter});

    if(values.status_filter !== 'all' && values.status_filter !== null && values.status_filter !== '' && values.status_filter !== undefined)
      this.filters.push({'key': 'status', 'value': values.status_filter});

   this.getSystemsRequests();
  }

  public getSystemsRequests() {
    this.loading = true;
    this.systemRequestService.getSystemsRequest(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
      response => {
        this.loading = false;
        this.requestData = response.json().data;

        if (response.json().meta.total > response.json().meta.total_filtered)
          this.totalRecords = response.json().meta.total_filtered;
        else
          this.totalRecords = response.json().meta.total;
      },
      error => {
        this.loading = false;
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'error' } );
      }
    );
  }

  

  getSystemRequestTypes(query?: string, filters?: any[]) {
    let page = 1;
    let per_page = 10;
    let sort = 'id';

    let typeOptions = [];

    this.systemRequestTypesService.getTypes(page, per_page, sort, query, filters).toPromise().then(
      response => {
        var requestTypes = response.json().data;
        for (let i = 0; i < requestTypes.length; i++)
          typeOptions.push({id: requestTypes[i].id, label: requestTypes[i].type, value: requestTypes[i].type });
      },
      error => {
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'error' } );
        typeOptions.push({ id: '', label: 'Error', value: 'Error' });
      }
    );
    return typeOptions;
  }
  
  getResponseTimeAsNumber(responseTime: string, time: number) {
  
  if (responseTime == '1 día')
    time = 1;
  
  if (responseTime == '2 días')
    time = 2;
  
  if (responseTime == '3 días o más')
    time = 3;

  return time;
  }
  public getDiffDateLoc(date_start, date_end) {
    return getDiffDate(date_start,date_end);
  }
  
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/systems-requests/systems-requests.component.ts